import {
  useEffect,
  useRef,
  useState,
  /* useEffect */
} from "react";
import { useLocation } from "react-router-dom";

import { HTTPErrorCallback } from "Helpers/Error";

import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

// import Verification from "./Components/Verification";
import NewPassword from "./Components/NewPassword";
import SendEmail from "./Components/SendEmail";
import * as S from "./styles";

const ForgotPassword = () => {
  const { state } = useLocation();
  const { api } = UseServices();
  const { showNotification } = UseNotification();

  const [login, setLogin] = useState(state?.login || "");
  const [loading, setLoading] = useState(false);

  const [token, setToken] = useState(null);

  const [sentEmail, setSentEmail] = useState("");

  const [reCaptchaToken, setReCaptchaToken] = useState(null);
  const captchaRef = useRef(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const tokenFromUrl = urlParams.get("token");
    if (tokenFromUrl) setToken(tokenFromUrl);
  }, []);

  const getVerificationCode = () => {
    if (!reCaptchaToken) {
      return showNotification(
        "warning",
        "Atenção!",
        "É necessário confirmar que você não é um robô.",
      );
    }

    setLoading(true);

    api
      .post("/sessions/password/request-token", {
        login,
        captcha_token: reCaptchaToken,
      })
      .then((response) => {
        setLoading(false);

        if (response.data.remaining_wait_time) {
          return showNotification(
            "warning",
            "Atenção!",
            `Já enviamos um email para você com as instruções para alterar sua senha. Você deve aguardar ${response.data.remaining_wait_time.value} minutos para tentar novamente.`,
          );
        }

        setSentEmail("success");
        showNotification(
          "success",
          "Sucesso!",
          "Enviamos um e-mail para você com as instruções para redefinir sua senha.",
        );
      })
      .catch((error) => {
        HTTPErrorCallback(error);
        setSentEmail("error");
        setLoading(false);
        setReCaptchaToken(null);
        captchaRef.current?.reset();
      });
  };

  const getComponent = () => {
    if (!token)
      return (
        <SendEmail
          loading={loading}
          login={login}
          setLogin={setLogin}
          getVerificationCode={getVerificationCode}
          sentEmail={sentEmail}
          setReCaptchaToken={setReCaptchaToken}
          captchaRef={captchaRef}
        />
      );

    return <NewPassword loading={loading} setLoading={setLoading} />;
  };

  return <S.Container>{getComponent()}</S.Container>;
};

export default ForgotPassword;
